import {ChangeEvent, ReactNode, useState} from "react";

type FilterSectionOption = {
    key: string;
    label: ReactNode;
    checked: boolean;
    disabled?: boolean;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

type Props = {
    title: string;
    options: FilterSectionOption[];
    columns?: 1 | 2;
    limit?: number;
};

export default function FilterSection({
    title,
    options,
    columns = 2,
    limit,
}: Props) {
    const [showAll, setShowAll] = useState(false);
    const visibleOptions = limit && !showAll ? options.slice(0, limit) : options;
    const gridColumns = columns === 1 ? "grid-cols-1" : "grid-cols-2";

    return (
        <div className="flex flex-col gap-2">
            <h3 className="font-semibold">{title}</h3>
            <div className={`grid ${gridColumns} gap-2 p-2`}>
                {visibleOptions.map((option) => (
                    <div
                        key={option.key}
                        className={`flex items-center gap-2 ${option.disabled ? 'opacity-30' : 'opacity-100'}`}
                    >
                        <input
                            type="checkbox"
                            id={`filter-${option.key}`}
                            checked={option.checked}
                            onChange={option.onChange}
                            disabled={option.disabled}
                            title={option.disabled ? "No phones of this brand satisfy the filters" : ""}
                            className={`${option.disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        />
                        <label
                            htmlFor={`filter-${option.key}`}
                            title={option.disabled ? "No phones of this brand satisfy the filters" : ""}
                            className={`text-sm ${option.disabled ? 'cursor-not-allowed text-gray-400' : 'cursor-pointer'}`}
                        >
                            {option.label}
                        </label>
                    </div>
                ))}
            </div>
            {limit && options.length > limit && (
                <button
                    type="button"
                    className="px-2 text-left text-gray-500"
                    onClick={() => setShowAll((prev) => !prev)}
                >
                    {showAll ? "Show less" : "Show all"}
                </button>
            )}
        </div>
    );
}



